angular.module('product', ['core', 'product-group', 'tax', 'currency', 'units', 'files'])
    .factory('Product', function ($resource) {
        var Product = $resource('/crm/api/product/:id', {}, {
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/product/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            unitConverters: {method: 'GET', isArray: true, url: "/crm/api/product/:id/unit-converter"}
        });
        Product.autocomplete = (q, limit) => Product.list({search: q, size: limit}).$promise;
        Product.autocomplete = (q, limit, language) => Product.list({search: q, size: limit, language: language}).$promise;
        return Product;
    })
    .service('ProductService', function ($rootScope, toastr, modals, Product, $filter) {
        this.add = () => {
            let entity = {
                active: true,
                id: null
            };
            return editModal(entity);
        };
        this.edit = id => {
            Product.get({id: id}).$promise.then(entity => editModal(entity));
        }
        this.remove = item => {
            return modals.confirmDelete(item.symbol + " (" + $filter("localized")(item.name) + ")", () => Product.delete({id: item.id}, () => $rootScope.$broadcast('product.updated')).$promise);
        };
        this.availableUnits = (product, currentUnit) => {
            let result = [];
            if (!product || !product.unitConverters)
                return result;

            result = product.unitConverters.map(converter => converter.destination);
            if (angular.isDefined(product.unit))
                result.push(product.unit);

            let filtered = result.map(unit => unit.id);
            if (angular.isDefined(currentUnit) && filtered.indexOf(currentUnit.id) < 0)
                result.push(currentUnit);

            return result;
        };
        this.importModal = () => modals.open('app/product/import-modal.tpl.html', 'ProductImportController', {}, {size: 'lg'});

        function editModal(entity) {
            return modals.open('app/product/edit-modal.tpl.html', 'ProductDialogController', entity, {size: 'lg'}, "$ctrl")
        }
    })
    .controller('ProductDialogController', function ($timeout, $scope, $rootScope, $uibModalInstance, data, toastr, Product, Language, $filter, Currency, Tax, ProductGroup, ProductService, Unit) {
        this.$onInit = () => {
            this.item = data
            if (!angular.isArray(this.item.unitConverters)) {
                this.item.unitConverters = [];
            }

            this.units = [];

            Unit.list().$promise.then(items => {
                this.units = items;
                if (!this.item.id) {
                    this.item.unit = Unit.getDefault(items);
                    this.item.defaultUnit = Unit.getDefault(items);
                }
            })

            Currency.query().$promise.then(items => {
                this.currencies = items;
                if (!this.item.id) {
                    this.item.netPriceBaseCurrency = Currency.getDefault(items);
                }
            })

            Tax.query().$promise.then(items => {
                this.taxRates = items;
                if (!this.item.id) {
                    this.item.tax = Unit.getDefault(items);
                }
            });

            ProductGroup.query().$promise.then(items => {
                this.groups = items;
                if (!this.item.id) {
                    this.item.group = items.find(item => item.defaultValue === true);
                }
            });
        }

        this.onLanguageChanged = (language) => {
            this.currentLang = language
        }

        this.sourceUnits = currentUnit => {
            return this.units.filter(unit => {
                if (currentUnit && currentUnit.id === unit.id)
                    return false;
                return this.item.unit.id === unit.id;
            })
        }

        this.destinationUnits = () => {
            return this.units.filter(unit => {
                if (this.item.unit.id === unit.id)
                    return false;
                return !isInDestinationUnitConverter(unit, this.item.unitConverters)
            })
        }

        function isInDestinationUnitConverter(unit, unitConverters) {
            let unitIds = unitConverters.map(u => u.destination !== null && u.destination.id)
            return unitIds.includes(unit.id)
        }

        this.addNewUnit = newUnitConverter => {
            this.item.unitConverters.push({
                destination: newUnitConverter,
                multiplier: 1,
            })
        }

        this.removeUnitConverter = $index => {
            let unit = this.item.unitConverters[$index].destination
            this.item.unitConverters.splice($index, 1)
            if (this.item.defaultUnit === unit) {
                delete this.item.defaultUnit
            }
        }

        this.onBaseUnitChanged = value => {
            this.item.defaultUnit = value;
            let unitLength = this.item.unitConverters.length;
            if (unitLength > 0) {
                this.item.unitConverters = [];
                let alertContent = 'Zmieniłeś podstawową jednostkę miary. Jednostki pomocnicze zostały USUNIĘTE. Uzupełnij jednostki pomocnicze dodając przelicznik względem nowej jednostki podstawowej.';
                toastr.error(alertContent, 'UWAGA', {
                    closeButton: true,
                    timeOut: 0
                })
            }
        }

        this.availableDefaultUnits = () => {
            let result = [];
            result = this.item.unitConverters.map(converter => converter.destination);

            let ids = result.map(it => it.id);

            if (this.item.unit && ids.indexOf(this.item.unit.id) < 0)
                result.push(this.item.unit);

            return result;
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Product.update(this.item).$promise;
            } else {
                promise = Product.save(this.item).$promise;
            }
            return promise.then(result => {
                $rootScope.$broadcast('product.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        }
    })
    .controller('ProductImportController', function ($cookies, $scope, $rootScope, $http, $uibModalInstance, toastr, FileUploader) {
        $scope.types = ["CSV", "CSV-SIMPLE"];

        $scope.import = {
            type: "CSV",
            charset: "CP1250",
            createRelatives: false
        };
        $scope.data = [];

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.uploader = createUploader();

        $scope.save = () => {
            $http.post('/crm/api/csv-import/save-data', {items: $scope.data, createRelatives: $scope.import.createRelatives})
                .then(result => {
                    toastr.success("Zapisano");
                    $rootScope.$broadcast('product.updated');
                    $uibModalInstance.close(result);
                });
        };

        function createUploader() {
            var uploader = new FileUploader({
                url: '/crm/api/csv-import/read-data',
                autoUpload: true,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            });
            uploader.onSuccessItem = function (fileItem, response, status, headers) {
                toastr.success("Wczytano dane z pliku");
                $scope.data = response;
                angular.element("input[type='file']").val(null);
            };
            uploader.onErrorItem = function (fileItem, rejection, status, headers) {
                if (angular.isArray(rejection.messages)) {
                    angular.forEach(rejection.messages, function (message, key) {
                        toastr.error(message);
                    });
                }
            };
            uploader.onBeforeUploadItem = function (item) {
                item.formData.push($scope.import);
            };
            return uploader;
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_PRODUCTS",
            path: "/product",
            ico: "fa fa-fw fa-barcode",
            name: 'product.menu',
            order: 20
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('productList', {
            parent: 'app',
            url: '/product?{page:int}&{size:int}&sort&search&{group:int}',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "productList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Product, $stateParams, localeService) => {
                    let params = angular.copy($stateParams);
                    params.language = localeService.getLanguage();
                    return Product.table(params).$promise;
                },
                groups: ProductGroup => ProductGroup.list().$promise
            }
        });
    });
